/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyJobPolicyIdQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicyJobPolicyIdQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicyJobPolicyIdQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicyJobPolicyIdQueryOperator>): PolicyJobPolicyIdQueryOperator {
        let obj = Object.assign(new PolicyJobPolicyIdQueryOperator(), model);
        PolicyJobPolicyIdQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyJobPolicyIdQueryOperator>): PolicyJobPolicyIdQueryOperator {
        if (!model) return null;
        return PolicyJobPolicyIdQueryOperator.newInstance(<PolicyJobPolicyIdQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyJobPolicyIdQueryOperator) {
        if (!obj) return;

        models.PolicyJobPolicyIdQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyJobPolicyIdQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicyJobPolicyIdQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy IDs to include
     */
    policy_ids: Array<string>;

}
